import { GoogleAnalyticsRouterInitializer, GoogleAnalyticsService, IGoogleAnalyticsRoutingSettings } from '@foxeet/analytics';
import { ComponentRef } from '@angular/core';

export function GoogleAnalyticsCookiesConsent(settings: IGoogleAnalyticsRoutingSettings, gaService: GoogleAnalyticsService) {
  const cookiesConsent = localStorage.getItem('haveAcceptedCookies');
  return cookiesConsent && JSON.parse(cookiesConsent) ? GoogleAnalyticsRouterInitializer(settings, gaService) : async (c: ComponentRef<any>) => {};
}
